import { render, staticRenderFns } from "./MyPageWorkManager.vue?vue&type=template&id=6d45b5a2&scoped=true&"
import script from "./MyPageWorkManager.vue?vue&type=script&lang=js&"
export * from "./MyPageWorkManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d45b5a2",
  null
  
)

export default component.exports